var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHubSecrets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m600 105c-148.5 0-269.25 120.75-269.25 269.25v178.65c0 8.25 6.75 15 15 15h508.5c8.25 0 15-6.75 15-15v-178.65c0-148.5-120.75-269.25-269.25-269.25zm175.8 432.9h-351.6v-159.15c0-97.051 78.898-175.8 175.8-175.8 96.898 0 175.8 78.75 175.8 175.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m923.55 537.9h-647.1c-25.199 0-45.449 20.398-45.449 45.449v466.2c0 25.055 20.25 45.453 45.449 45.453h647.1c25.199 0 45.449-20.398 45.449-45.449v-466.2c0-25.051-20.25-45.453-45.449-45.453zm-252.45 355.8c3 7.3516 1.9492 15.75-2.3984 22.199-4.5039 6.6016-11.852 10.5-19.805 10.5h-97.801c-7.9492 0-15.301-3.8984-19.801-10.5-4.3516-6.4492-5.3984-14.852-2.3984-22.199l17.25-44.098c-17.551-15.301-27.75-37.352-27.898-61.199-0.14844-43.949 35.551-80.699 79.5-81.898 22.199-0.60156 43.199 7.6484 59.25 23.102 15.898 15.602 24.75 36.449 24.75 58.648 0 23.852-10.199 46.051-27.898 61.352z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubSecrets);
export default __webpack_public_path__ + "static/media/hub-secrets.3fc13abc7d88a4099e375d14c6b4750a.svg";
export { ForwardRef as ReactComponent };